module.exports = __webpack_public_path__ + "static/media/інпрофіт-виготовлення-та-модернізація-зерносушарок.467a064f.jpg";